
import type React from "react"

import { useEffect } from "react"

export function PointerEventsProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    // Immediately fix any existing pointer-events issues
    if (window.getComputedStyle(document.body).pointerEvents === "none") {
      console.log("Found pointer-events: none on body during initialization. Fixing...")
      document.body.style.pointerEvents = "auto"
    }

    // Safety mechanism to restore pointer events if they get stuck
    const interval = setInterval(() => {
      const bodyStyle = window.getComputedStyle(document.body)
      if (bodyStyle.pointerEvents === "none") {
        console.log("Automatically restoring pointer events")
        document.body.style.pointerEvents = "auto"
      }
    }, 1000) // Check more frequently

    // Listen for escape key to restore pointer events
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        document.body.style.pointerEvents = "auto"
      }
    }

    // Monitor changes to body style
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "style" &&
          document.body.style.pointerEvents === "none"
        ) {
          console.log("Body pointer-events set to none")

          // Set a timeout to restore pointer events after a short delay
          // This allows the modal to display properly but prevents it from getting stuck
          setTimeout(() => {
            if (window.getComputedStyle(document.body).pointerEvents === "none") {
              console.log("Restoring pointer events after delay")
              document.body.style.pointerEvents = "auto"
            }
          }, 500)
        }
      })
    })

    observer.observe(document.body, { attributes: true })
    window.addEventListener("keydown", handleKeyDown)

    return () => {
      clearInterval(interval)
      observer.disconnect()
      window.removeEventListener("keydown", handleKeyDown)
    }
  }, [])

  return <>{children}</>
}
